import React from 'react';
import styles from './PillCellRenderer.module.scss';

export const PillCellRenderer = ({ label, isActive }) => {
    return <span className={isActive ? styles.PillActive : styles.PillInactive}>{label}</span>;
};
